import React from 'react';
import ReactMarkdown from 'react-markdown';
import { cn } from '../../../../lib/utils';
import { CalloutBlock as CalloutBlockType } from '../../../../types/report-builder';

interface Props {
  block: CalloutBlockType;
}

const variantStyles = {
  info: 'border-l-primary bg-accent',
  warning: 'border-l-[var(--go-bittersweet)] bg-[color:rgba(255,116,97,0.08)]',
  success: 'border-l-[var(--go-teal)] bg-[color:rgba(0,162,198,0.08)]',
};

const CalloutBlock: React.FC<Props> = ({ block }) => {
  const variant = block.variant ?? 'info';

  return (
    <div
      className={cn(
        'my-6 rounded-[24px] border border-border/70 border-l-4 p-5 prose prose-sm max-w-none text-foreground shadow-[var(--shadow-card)]',
        variantStyles[variant]
      )}
    >
      <ReactMarkdown>{block.markdown}</ReactMarkdown>
    </div>
  );
};

export default CalloutBlock;
